import { createIndexCache, createKeyedResourceCache } from "./apiResourceCache";

export const getCollections = createIndexCache("/public/collections");

const getCollectionItemsCached = createKeyedResourceCache({
  fetchPath: (key) => `/public/collections/${encodeURIComponent(key)}`,
  transform: (data) => (Array.isArray(data?.items) ? data.items : []),
});

export async function getCollectionItems(key) {
  if (!key) return [];
  return getCollectionItemsCached(key);
}

export function prefetchCollectionItems(key) {
  if (!key) return;
  void getCollectionItems(key);
}

/** Warm `/public/collections` so the Collections tab is instant after idle or hover. */
export function prefetchCollectionsIndex() {
  void getCollections();
}
